<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!-- Button to Open the Modal -->
        <button type="button" id="btnLoadList" (click)="GetRolesList()" style="display:none">Get</button>
        <button type="button" (click)="show()" id="btn_AddNew" style="display:none">
          Add
        </button>

        <table #dataTable class="display" style="width:100%"></table>

        <!-- The Modal -->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="divRolePopupCT">
              <!-- Modal Header -->
              <div class="modal-header" style="top:-12px;position:relative;">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <!-- Modal body -->
              <div class="modal-body" id="divRoleBody" style="overflow: hidden !important; position: relative; top: -30px;">
                <div class="row">
                  <div [ngClass]="checkAdmin ? 'col-4' : 'col-6'">
                    <div class="form-group label-floating">
                      <label for="txtRoleName" class="control-label">Role Name<em>*</em></label>
                      <input class="form-control" type="text" maxlength="30" id="txtRoleName" />
                    </div>
                  </div>
                  <div [ngClass]="checkAdmin ? 'col-4' : 'col-6'">
                    <div class="form-group label-floating">
                      <label for="txtDescription" class="control-label">Description<em>*</em></label>
                      <input class="form-control" id="txtDescription" maxlength="100" />
                    </div>
                  </div>
                  <div class="col-md-4 row" *ngIf="checkAdmin">
                    <div class="col-md-6">
                      <div class="form-group label-floating">
                        <label for="txtDashboardLink" class="control-label">Dashboard Link<em>*</em></label>
                        <input class="form-control" id="txtDashboardLink" maxlength="100" />
                        <select id="ddlDashboardLink" class="form-control select2" style="display:none">
                          <option *ngFor="let item of aMenuList" value={{item.MenuID}}>{{item.LinkPath}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group label-floating">
                        <label for="txtDashboardLink" class="control-label">Is Visible Header Icon</label><br />
                        <input Id='chkIsVisibleHeaderIcon' type='checkbox' />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">

                  <span style="position:relative;left:5px;float:right;">
                    <label for="MenuID" class="control-label">Select All&nbsp;</label> <input class="chkActionAll" type="checkbox" name="ChkAll">
                  </span>
                  <div id="MenuTab" [ngClass]="checkAdmin ? 'col-6' : 'col-12'">
                    <div class="col-md-12">
                      <div class="row tblRightsList col-md-12 fixTableHead">
                        <table class="table" id="tblRightsList">
                          <thead>
                            <tr>
                              <th>Menu Name</th>
                              <th>View</th>
                              <th>Add</th>
                              <th>Update</th>
                              <th>Delete</th>
                              <th>Clone</th>
                            </tr>
                          </thead>
                          <tbody class="tblRightsListBody">
                            <tr *ngFor="let item of aMenuList" id="tr{{ item.MenuID }}">
                              <td *ngIf="(item.ParentMenu == 0)" colspan="5" class="tdHeading">{{ item.MenuName }}</td>
                              <td *ngIf="(item.ParentMenu != 0)">{{ item.MenuName }}</td>
                              <td *ngIf="(item.ParentMenu != 0)"><input class='chkAction' type='checkbox' name='View' disabled="{{ item.ActionView }}" /></td>
                              <td *ngIf="(item.ParentMenu != 0)"><input class='chkAction' type='checkbox' name='Add' disabled="{{ item.ActionAdd }}" /></td>
                              <td *ngIf="(item.ParentMenu != 0)"><input class='chkAction' type='checkbox' name='Update' disabled="{{ item.ActionEdit }}" /></td>
                              <td *ngIf="(item.ParentMenu != 0)"><input class='chkAction' type='checkbox' name='Delete' disabled="{{ item.ActionDelete }}" /></td>
                              <td *ngIf="(item.ParentMenu != 0)"><input class='chkAction' type='checkbox' name='Clone' disabled="{{ item.CloneDelete }}" /></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div id="ColumnTab" class="col-6" style="top:-12px;" *ngIf="checkAdmin">
                    <div class="row">
                      <div class="col-sm-4">
                        <label>Module</label>
                        <select id="ddlGridName" class="form-control select2">
                          <option value=0>All</option>
                          <option *ngFor="let item of agridList" value={{item.GridID}}>{{item.ModuleName}}</option>
                        </select>
                      </div>
                      <div class="col-sm-4">
                        <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="GetGridTrasList()">Search</button>
                      </div>

                      <div class="col-sm-4">
                        <span style="position:relative;right:18px;float:right;top:40px;">
                          <label for="Column" class="control-label">Select All&nbsp;</label> <input class="chkColumnAll" type="checkbox" name="ChkColumnAll">
                        </span>
                      </div>

                    </div>

                    <div class="row tblColumnList col-md-12 fixTableHead">
                      <table class="table" id="tblColumnList">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Grid Name</th>
                            <th>Column</th>
                            <th>View</th>
                            <th>Update</th>
                          </tr>
                        </thead>
                        <tbody class="tblColumnListBody">
                          <tr *ngFor="let item of agridTransList" id="tr{{ item.TransID }}">
                            <td>{{ item.TransID }}</td>
                            <td>{{ item.GridName }}</td>
                            <td>{{ item.ColumnTitle }}</td>
                            <td><input class='chkColAction' type='checkbox' name='View' [checked]="item.ActionView" /></td>
                            <td><input class='chkColAction' type='checkbox' name='Update' [checked]="item.ActionEdit" /></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>


                </div>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateRoleDetails()">{{popUpButtonText}}</button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>
